const UnauthorizedPage = () => {
  return (
    <h1>Unauthorized</h1>
  );
};

export default UnauthorizedPage;